export default "__VITE_ASSET__Coz5Xakq__"